import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-12">
      <div className="max-w-4xl mx-auto relative rounded-2xl overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              'url(https://readdy.ai/api/search-image?query=warm%20gradient%20abstract%20background%20with%20flowing%20golden%20and%20soft%20orange%20light%20rays%2C%20elegant%20minimalist%20composition%2C%20ethereal%20atmosphere%2C%20warm%20inviting%20energy&width=1200&height=500&seq=cta-bg-91niu&orientation=landscape)',
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 to-black/45" />
        <div className="relative z-10 px-8 py-16 md:py-20 text-center">
          <h2 className="font-heading text-3xl md:text-4xl text-background-50 mb-4">
            加入91牛社区，开启全新体验
          </h2>
          <p className="text-background-100/80 max-w-lg mx-auto mb-8 text-sm md:text-base">
            立即注册91牛账号，免费体验所有核心功能，与50万+用户一起高效工作
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#"
              className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-8 py-3.5 rounded-full text-sm transition-all cursor-pointer"
            >
              免费注册
            </a>
            <Link
              to="/about#contact"
              className="whitespace-nowrap border border-background-50/40 hover:border-background-50 text-background-50 font-medium px-8 py-3.5 rounded-full text-sm transition-all cursor-pointer"
            >
              联系客服
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}